/** The available wireframe UX variants for the medical questionnaire step. */
enum MedicalUxVersion {
  CombinedPage = "medicalUxVersion.combinedPage",
  OneAtATime = "medicalUxVersion.oneAtATime",
  AutoScroll = "medicalUxVersion.autoScroll",
  CheckboxOptIn = "medicalUxVersion.checkboxOptIn",
  NoToAll = "medicalUxVersion.noToAll"
}

export default MedicalUxVersion;
